import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaTimes, FaCamera } from 'react-icons/fa';
import StepProgressBar from './StepProgressBar';
import { DatePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const TransactionDetailModal = ({ show, onHide, onSave, onBack, paymentData, currentStep }) => {
  const [paymentDate, setPaymentDate] = useState(new Date());
  const [txnRemarks, setTxnRemarks] = useState('');
  const [proofImages, setProofImages] = useState([]);

  const getCurrentDateTime = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes} AM`;
  };

  const handleSave = () => {
    const finalData = {
      ...paymentData,
      paymentDate,
      txnRemarks,
      proofImages
    };
    onSave(finalData);
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    setProofImages([...proofImages, ...files]);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md" backdrop="static" dialogClassName="custom-modal-width">
      <Modal.Header className="border-0 pb-0">
        <div className="w-100">
          
          {/* Header Content */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div>
              <h5 className="mb-0 fw-bold fs-5">Step 3 of 3: Txn Detail</h5>
              <small className="text-muted">Fill in the details below to add</small>
            </div>
            <div className="d-flex gap-2">
             
              <Button variant="link" onClick={onBack} className="p-0 text-secondary">
                <FaTimes size={20} />
              </Button>
            </div>
          </div>
          {/* Progress Bar */}
          {/* <StepProgressBar currentStep={currentStep} totalSteps={3} /> */}
        </div>
      </Modal.Header>
      
      <Modal.Body className="pt-2">
        <div className="row g-3">
          {/* Amount Paid Via */}
          <div className="col-12">
            <Form.Group>
              <Form.Label className="fw-bold text-uppercase text-muted mb-2">
                AMOUNT PAID VIA
              </Form.Label>
              <Form.Control
                type="text"
                value={paymentData?.paymentMode || 'Cash On Hand'}
                disabled
                className="bg-light border-0"
              />
            </Form.Group>
          </div>

          {/* Amount Paid */}
          <div className="col-12">
            <Form.Group>
              <Form.Label className="fw-bold text-uppercase text-muted mb-2">
                AMOUNT PAID
              </Form.Label>
              <div className="input-group">
                <span className="input-group-text bg-light border-0">₹</span>
                <Form.Control
                  type="text"
                  value={paymentData?.amountPaid || '73'}
                  disabled
                  className="bg-light border-0 border-start-0"
                />
              </div>
            </Form.Group>
          </div>

          {/* Payment Date */}
          <div className="col-12">
            <Form.Group>
              <Form.Label className="fw-bold text-uppercase text-muted mb-2">
                PAYMENT DATE 
                <span className="text-danger float-end">*</span>
              </Form.Label>
              <DatePicker
                name="paymentdate"
                value={paymentDate ? new Date(paymentDate) : null}
                onChange={(value) => setPaymentDate(value)}
                format="dd-MMM-yyyy"
                placeholder="dd-mmm-yyyy"
                oneTap
                style={{ width: "100%", height: "38px", borderRadius: "4px" }}
              />
            </Form.Group>
          </div>

          {/* Transaction Remarks */}
          <div className="col-12">
            <Form.Group>
              <Form.Label className="fw-bold text-uppercase text-muted mb-2">
                TXN REMARKS 
                <span className="text-muted float-end">Optional</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter Remarks here"
                value={txnRemarks}
                onChange={(e) => setTxnRemarks(e.target.value)}
                className="bg-white"
              />
            </Form.Group>
          </div>

          {/* Transaction Proof Images */}
          <div className="col-12">
  <Form.Group>
    <div className="d-flex justify-content-between align-items-center mb-1">
      <Form.Label className="fw-bold text-uppercase text-muted mb-0">
        TXN PROOF IMAGES
      </Form.Label>
      <small className="text-muted">Optional</small>
    </div>

    <div
      className="txn-proof-box text-center p-3 rounded"
      onClick={() => document.getElementById("txnProofUpload").click()}
    >
      <FaCamera size={18} className="text-pink me-2" />
      <span className="text-pink fw-semibold">Txn Proof Images</span>

      <input
        type="file"
        id="txnProofUpload"
        multiple
        accept="image/*"
        onChange={handleImageUpload}
        className="d-none"
      />
    </div>

    {proofImages.length > 0 && (
      <div className="mt-2 text-success small">
        {proofImages.length} image(s) selected
      </div>
    )}
  </Form.Group>

  <style>
    {`
      .txn-proof-box {
        border: 2px dashed #e0e0e0;
        background: #fff;
        color: #57c094ff;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
      }

      .txn-proof-box:hover {
        background: #f5fffdff;
        border-color: #4dffb5ff;
      }

      .text-pink {
        color: #50bd8fff !important;
      }
    `}
  </style>
</div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-2">
        <Button 
                className="gradient-button"
                onClick={handleSave}
             
              >
                Save (F2)
              </Button>
      </Modal.Footer>

      <style jsx>{`
        .input-group-text {
          border-right: 0;
        }
        
        .border-start-0 {
          border-left: 0 !important;
        }
        
        .border-start-0:focus {
          border-left: 0 !important;
        }
        
        .bg-light:disabled {
          opacity: 1;
          color: #495057;
        }
        
        kbd {
          background-color: #e9ecef;
          color: #495057;
          padding: 0.2rem 0.4rem;
          border-radius: 0.25rem;
          font-size: 0.8rem;
        }
        
        .border-dashed {
          border-style: dashed !important;
        }
        
        .form-label {
          font-size: 0.8rem;
          letter-spacing: 0.5px;
        }
        
        .modal-body {
          max-height: 70vh;
          overflow-y: auto;
        }
            .custom-modal-width {
    max-width: 600px !important; /* or any px/% value */
    width: 600px !important;
  }
      `}</style>
    </Modal>
  );
};

export default TransactionDetailModal;